module.exports = __webpack_public_path__ + "static/logo-appscope-1d7650dd209533ad4575a87ad6a46c74.svg";